import { computed } from 'nanostores'
import { $dialogQueue, type DialogQueueItem } from './stores'

export const $openedDialog = computed(
  [$dialogQueue],
  (queue) => queue[0] as DialogQueueItem | undefined,
)
